
import {
  defineComponent,
  onBeforeMount,
  reactive,
  ref,
  watch,
} from 'vue';
import { Card } from 'ant-design-vue';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import PreviewPdf from '@/core/components/Modal/PreviewPdf.vue';
import SelecionarFiltroPeriodoMovimentoComercial from '@/components/Compartilhados/SelecionarFiltroPeriodoMovimentoComercial.vue';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import SelecionarAgrupadorRelatorio from '@/components/Relatorios/Vendas/PainelVendas/SelecionarAgrupadorRelatorio.vue';
import SelecionarTipoOperacao from '@/components/Cadastros/SelecionarTipoOperacao.vue';
import SelecionarCliente from '@/components/Cadastros/Pessoas/Clientes/SelecionarCliente.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import Icone from '@/core/components/Icone.vue';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import { IDTORelatorioVenda } from '@/models/Relatorios/Venda/IDTORelatorioVenda';
import { IArquivoPdf } from '@/core/models/IArquivoPdf';
import { IParametrosRelatorioVendas } from '@/models/ParametrosRequisicao/Vendas/IParametrosRelatorioVendas';
import { ECustomRenderRow, IColumn } from '@/core/models/AntDesign/IColumn';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import { ETipoArquivo } from '@/core/models/Enumeradores/ETipoArquivo';
import { EStatusRetornoRequisicao, IRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';
import ServicoRelatoriosVendas from '@/servicos/Relatorios/ServicoRelatoriosVendas';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import storeSistema from '@/store/storeSistema';
import { ISalvamentoAutomatico } from '@/models/Entidades/MeuSistema/ISalvamentoAutomatico';
import SelecionarCamposRelatorioVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarCamposRelatorioVendas.vue';
import SelecionarTipoRelatorioPainelVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarTipoRelatorioPainelVendas.vue';
import { IDadosRelatorio, IDadosRelatorioCampo } from '@/models/Entidades/Relatorios/DadosRelatorio';
import SelecionarRelatorioPainelVendas from '@/components/Relatorios/Vendas/PainelVendas/SelecionarRelatorioPainelVendas.vue';
import ServicoDadosRelatorio from '@/servicos/Relatorios/ServicoDadosRelatorio';

export default defineComponent({
  name: 'PainelRelatorioVendasIndex',

  components: {
    TituloPadrao,
    Card,
    Icone,
    PreviewPdf,
    SelecionarFiltroPeriodoMovimentoComercial,
    SelecionarDataInicialFinal,
    SelecionarAgrupadorRelatorio,
    SelecionarTipoRelatorioPainelVendas,
    SelecionarTipoOperacao,
    SelecionarCliente,
    SelecionarProduto,
    SelecionarColaborador,
    SelecionarCamposRelatorioVendas,
    SelecionarRelatorioPainelVendas,
  },

  setup(props) {
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);

    const {
      telaBase,
      preencherEmpresasDisponiveis,
      filtrarPermissaoDadosUsuarioMultiEmpresas,
      apresentarMensagemAlerta,
      apresentarMensagemErro,
      apresentarMensagemSucesso,
    } = useTelaBase();

    const { gradeBase, defineAlturaScrollDinamica } = useGradeBase();

    const servicoRelatorioVenda = new ServicoRelatoriosVendas();
    const permissaoServico = ref<boolean>(false);
    const servicoSistema = new ServicoSistema();
    const servicoDadosRelatorio = new ServicoDadosRelatorio();

    const state = reactive({
      identificadorRecurso: 'PAINEL_RELATORIO_VENDAS',
      tituloRecurso: 'Painel de Relatório de Vendas',
      carregandoTela: true,
      periodo: 1,
      dados: {} as IDTORelatorioVenda,
      dataInicialSelecionada: '',
      dataFinalSelecionada: '',
      filtroPeriodo: 0,
      dataAtual: '',
      empresaSelecionada: 0,
      colunas: [] as IColumn[],
      telaMobile: false,
      qtdSelecionados: 0,
      arquivoPdf: [] as IArquivoPdf[],
      tipoRelatorio: 1,
      tipoAgrupador: 1,
      tipoOperacao: [] as number[],
      vendedores: [] as number[],
      clientes: [] as number[],
      produtos: [] as number[],
      camposRelatorio: '',
      parametros: {} as IParametrosRelatorioVendas,
      cacheAutomatico: {} as ISalvamentoAutomatico,
      descricao: '',
      mostrarConfiguracao: 1,
      mostrarFiltros: 0,
      dadosRelatorio: {} as IDadosRelatorio,
      dadosRelatorioCampos: '',
      codigoRelatorio: 0,
      nomeRelatorio: '',
    });

    function permitirMovimentacao(evt: any) {
      const item = evt.draggedContext.element;
      return item.key !== 'id';
    }

    function atualizarPosicoes() {
      state.colunas.forEach((col, i) => {
        // eslint-disable-next-line no-param-reassign
        col.position = i;
      });
    }

    const mapaCampos: Record<string, string> = {
      ValorTotal: 'valorTotal',
      ValorUnitario: 'valorUnitario',
      ValorDesconto: 'valorDesconto',
      Quantidade: 'quantidade',
      DataVenda: 'dataVenda',
      DataEmissao: 'dataEmissao',
      Produto: 'produto',
      Participacao: 'participacao',
      Cliente: 'cliente',
      'CPF/CNPJ': 'cpfCnpj',
      Cidade: 'cidade',
      UF: 'uf',
      Unidade: 'unidade',
      NumeroVenda: 'numeroVenda',
      NumeroNota: 'numeroNota',
      Vendedor: 'vendedor',
      FormaPagamento: 'formaPagamento',
      TipoOperacao: 'tipoOperacao',
    };

    const mapaTitulo: Record<string, string> = {
      ValorTotal: 'Valor Total',
      ValorUnitario: 'Valor Unitário',
      ValorDesconto: 'Valor Desconto',
      Quantidade: 'Quantidade',
      DataVenda: 'Data Venda',
      DataEmissao: 'Data Emissão',
      Produto: 'Produto',
      Participacao: '% Part.',
      Cliente: 'Cliente',
      'CPF/CNPJ': 'CPF/CNPJ',
      Cidade: 'Cidade',
      UF: 'UF',
      Unidade: 'Unidade',
      NumeroVenda: 'Pedido',
      NumeroNota: 'NF-e',
      Vendedor: 'Vendedor',
      FormaPagamento: 'Forma de Pagamento',
      TipoOperacao: 'Tipo de Operação',
    };

    function obterCustomizacao(campo: string): number | undefined {
      switch (campo) {
        case 'DataVenda':
        case 'DataEmissao':
          return ECustomRenderRow.MascararData;

        case 'ValorTotal':
        case 'ValorUnitario':
        case 'ValorDesconto':
        case 'Quantidade':
          return ECustomRenderRow.MascararFracionado;

        case 'CPF/CNPJ':
          return ECustomRenderRow.MascararCPFCNPJ;

        case 'Participacao':
          return ECustomRenderRow.MascararPorcentagem;

        default:
          return ECustomRenderRow.HTMLPersonalizado;
      }
    }

    function montarColunas(campos: string) {
      const colunaId: IColumn = {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        position: 0,
        visible: false,
        ellipsis: false,
        ordering: false,
        width: 0,
        align: 'left',
      };

      if (!campos) {
        state.colunas = [colunaId];
        return;
      }

      const listaCampos = campos
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      const colunasDinamicas = listaCampos.map((campo, i) => {
        const dataIndex = mapaCampos[campo];
        const customRender = obterCustomizacao(campo);

        return {
          title: mapaTitulo[campo],
          dataIndex,
          key: campo,
          position: i + 1,
          visible: true,
          ellipsis: true,
          ordering: true,
          align: 'left',
          customRenderRow: customRender,

          sorter: (a: any, b: any) => {
            const valA = a[dataIndex];
            const valB = b[dataIndex];

            if (
              customRender === ECustomRenderRow.MascararFracionado
          || customRender === ECustomRenderRow.MascararPorcentagem
            ) {
              return (valA || 0) - (valB || 0);
            }

            if (customRender === ECustomRenderRow.MascararData) {
              return new Date(valA).getTime() - new Date(valB).getTime();
            }

            return (valA || '').toString().localeCompare((valB || '').toString());
          },
        };
      });

      state.colunas = [colunaId, ...colunasDinamicas];
    }

    function obterIdentificadorCache(): string {
      return `PAINEL_RELATORIO_VENDAS_${storeSistema.getters.codigoUsuarioAutenticado()}`;
    }

    function salvarCache() {
      const identificador = obterIdentificadorCache();
      state.cacheAutomatico.data = UtilitarioData.obterDataAtual();
      state.cacheAutomatico.codigoEmpresa = state.parametros.empresa;
      state.cacheAutomatico.codigoUsuario = storeSistema.getters.codigoUsuarioAutenticado();
      state.cacheAutomatico.identificador = telaBase.identificadorRecurso;
      state.cacheAutomatico.dados = JSON.stringify({
        ...state.parametros,
        codigoRelatorio: state.codigoRelatorio,
        nomeRelatorio: state.nomeRelatorio,
      });
      servicoSistema.salvamentoAutomaticoLocalStorage(`${identificador}`, state.cacheAutomatico);
    }

    async function recuperarCache() {
      const cacheRestaurado = await servicoSistema.obterSalvamentoAutomaticoLocalStorage(obterIdentificadorCache());

      if (UtilitarioGeral.valorValido(cacheRestaurado)) {
        const cache = JSON.parse(cacheRestaurado.dados);
        state.parametros = cache;
        state.periodo = cache.periodo;
        if (cache.codigoRelatorio) {
          console.log('Codigo Relatorio: ', cache);
          state.codigoRelatorio = cache.codigoRelatorio;
          state.nomeRelatorio = cache.nomeRelatorio;
        }

        return true;
      }
      return false;
    }

    function prencheDatasPeriodo() {
      // eslint-disable-next-line default-case
      switch (state.periodo) {
        case EFiltroPeriodoMovimentoComercial.Hoje:
          state.dataInicialSelecionada = state.dataAtual;
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ontem:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          state.dataFinalSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 1);
          break;

        case EFiltroPeriodoMovimentoComercial.SemanaAtual:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 7);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.MesAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaMes(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaMes(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.AnoAtual:
          state.dataInicialSelecionada = UtilitarioData.obterPrimeiroDiaAno(state.dataAtual);
          state.dataFinalSelecionada = UtilitarioData.obterUltimoDiaAno(state.dataAtual);
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos15Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 15);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos30Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 30);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos60Dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 60);
          state.dataFinalSelecionada = state.dataAtual;
          break;

        case EFiltroPeriodoMovimentoComercial.Ultimos90dias:
          state.dataInicialSelecionada = UtilitarioData.diminuirDiaNaData(state.dataAtual, 90);
          state.dataFinalSelecionada = state.dataAtual;
          break;
      }
    }

    async function buscarRelatorio() {
      if (state.camposRelatorio.trim() === '') {
        return;
      }
      prencheDatasPeriodo();

      const parametrosConsulta = {} as IParametrosRelatorioVendas;

      parametrosConsulta.empresa = state.empresaSelecionada;
      parametrosConsulta.ordenacao = [];
      parametrosConsulta.periodo = state.periodo;
      parametrosConsulta.dataInicial = state.dataInicialSelecionada;
      parametrosConsulta.dataFinal = state.dataFinalSelecionada;
      parametrosConsulta.ordenacao.push('Status', 'DataEmissao|DESC');

      parametrosConsulta.tipoOperacao = state.tipoOperacao;
      parametrosConsulta.clientes = state.clientes;
      parametrosConsulta.vendedores = state.vendedores;
      parametrosConsulta.produtos = state.produtos;

      parametrosConsulta.tipoRelatorio = state.tipoRelatorio;
      parametrosConsulta.tipoAgrupador = state.tipoAgrupador;

      parametrosConsulta.qtdeRegistrosPagina = 1000;

      parametrosConsulta.camposRelatorio = state.camposRelatorio
        .split(',')
        .map((c) => c.trim())
        .filter((c) => c.length > 0);

      telaBase.carregando = true;
      state.parametros = parametrosConsulta;
      salvarCache();
      const listaPaginada = await servicoRelatorioVenda.obterRelatorioVendas(parametrosConsulta);
      state.dados = listaPaginada;
      telaBase.carregando = false;
    }

    async function imprimir(tipoArquivoRelatorio: ETipoArquivo) {
      telaBase.carregando = true;

      if (!UtilitarioGeral.validaLista(state.dados.itens)) {
        await buscarRelatorio();
      }

      const retornoRelatorio = await servicoRelatorioVenda.obterArquivRelatoriooVenda(
        tipoArquivoRelatorio,
        state.parametros,
      );

      telaBase.carregando = false;

      if (retornoRelatorio.status === EStatusRetornoRequisicao.Sucesso) {
        if (tipoArquivoRelatorio === ETipoArquivo.PDF) {
          state.arquivoPdf = [{
            nome: '',
            link: retornoRelatorio.link,
          }];
        } else {
          UtilitarioGeral.downloadArquivo(retornoRelatorio.link);
        }
      } else if (retornoRelatorio.status === EStatusRetornoRequisicao.Alerta) {
        apresentarMensagemAlerta(retornoRelatorio.mensagem);
      } else {
        apresentarMensagemErro(retornoRelatorio.mensagem);
      }
    }

    async function atualizarSelecaoEmpresas() {
      telaBase.empresasSelecionadas = [dadosEmpresa.value.codigoEmpresa];
      telaBase.permissaoDados = await filtrarPermissaoDadosUsuarioMultiEmpresas(
        telaBase.empresasSelecionadas,
      );

      permissaoServico.value = await new ServicoSistema()
        .validarPermissaoModulo(dadosEmpresa.value.codigoEmpresa, 8);
    }

    const filtros = ref({ data: null, tipo: null, status: null });

    async function periodoAlterado() {
      if (state.filtroPeriodo !== EFiltroPeriodoMovimentoComercial.Personalizado) {
        await buscarRelatorio();
      }
    }

    async function ValidarCampos() {
      if (state.dadosRelatorio.campos.length === 0) {
        apresentarMensagemAlerta('É necessário adicionar os campos');
        return false;
      }
      return true;
    }

    async function converterCamposRelatorio(
      valor: string,
      codigoRelatorio: number,
    ): Promise<IDadosRelatorioCampo[]> {
      if (!valor) return [];

      return valor
        .split(',')
        .map((c) => c.trim())
        .filter(Boolean)
        .map((campo, index) => ({
          codigo: 0,
          codigoRelatorio,
          campo,
          ordem: index + 1,
        }));
    }

    async function salvar() {
      let retorno: IRetornoRequisicao = { codigoRegistro: 0, status: 0, mensagem: '' };
      if (state.dadosRelatorio.codigo === 0) {
        state.dadosRelatorio.campos = await converterCamposRelatorio(
          state.dadosRelatorioCampos,
          state.dadosRelatorio.codigo,
        );
        if (!await ValidarCampos()) { return; }
        retorno = await servicoDadosRelatorio.incluir(state.dadosRelatorio);
      } else {
        salvarCache();
        state.dadosRelatorio.campos = await converterCamposRelatorio(
          state.camposRelatorio,
          state.dadosRelatorio.codigo,
        );
        if (!await ValidarCampos()) { return; }
        retorno = await servicoDadosRelatorio.alterar(state.dadosRelatorio);
      }

      if (retorno.status === EStatusRetornoRequisicao.Sucesso) {
        apresentarMensagemSucesso(retorno.mensagem);
      } else {
        apresentarMensagemErro(retorno.mensagem);
      }
    }

    async function obterDadosRelatorio() {
      state.dadosRelatorio = await servicoDadosRelatorio.obter(state.codigoRelatorio, state.empresaSelecionada);
      if (!state.camposRelatorio) {
        state.camposRelatorio = state.dadosRelatorio.campos.map((c) => c.campo).join(', ');
      }

      state.tipoRelatorio = state.dadosRelatorio.tipoRelatorio;
      state.tipoAgrupador = state.dadosRelatorio.agrupador;
    }

    watch(
      () => state.camposRelatorio,
      (novoValor) => {
        montarColunas(novoValor);
      },
      { immediate: true },
    );

    onBeforeMount(async () => {
      state.empresaSelecionada = storeSistema.getters.codigoEmpresaOperacao();
      telaBase.identificadorRecurso = state.identificadorRecurso;

      const temCache = await recuperarCache();

      if (!temCache || state.codigoRelatorio === 0) {
        state.codigoRelatorio = await servicoDadosRelatorio.obterCodigo(state.empresaSelecionada);
      }

      if (state.codigoRelatorio > 0) {
        await obterDadosRelatorio();
        state.mostrarConfiguracao = 0;
        state.mostrarFiltros = 1;
      } else {
        state.dadosRelatorio.codigo = 0;
        state.dadosRelatorio.codigoEmpresa = state.empresaSelecionada;
        state.dadosRelatorio.tipoRelatorio = 1;
        state.dadosRelatorio.agrupador = 1;
        state.mostrarConfiguracao = 1;
        state.mostrarFiltros = 0;
      }

      await preencherEmpresasDisponiveis();
      state.dataAtual = await new ServicoSistema().obterDataAtual();

      const dadosEmpresaCache = storeSistema.state.empresasDisponiveis
        .find((c) => c.codigoEmpresa === state.empresaSelecionada);
      if (dadosEmpresaCache) dadosEmpresa.value = dadosEmpresaCache;
    });
    return {
      props,
      filtros,
      state,
      dadosEmpresa,
      telaBase,
      gradeBase,
      buscarRelatorio,
      atualizarSelecaoEmpresas,
      periodoAlterado,
      atualizarPosicoes,
      permitirMovimentacao,
      UtilitarioMascara,
      UtilitarioData,
      ECustomRenderRow,
      EFiltroPeriodoMovimentoComercial,
      imprimir,
      ETipoArquivo,
      window,
      defineAlturaScrollDinamica,
      salvar,
      obterDadosRelatorio,
    };
  },
});
